import { Select } from '@lokalise/louis';

import type { Option, Options } from './types';

interface FileFormatInputProps {
    value: Option | undefined;
    options: Options;
    onChange: (value: Option) => void;
}

const FileFormatInput = ({ value, options, onChange }: FileFormatInputProps) => (
    <Select
        value={value}
        options={options}
        aria-labelledby="FileFormatInput"
        name="file-format-input"
        onChange={(option) => {
            if (option === null) {
                return;
            }

            onChange(option);
        }}
        maxMenuHeight={438}
    />
);

export default FileFormatInput;
